<template>
  <v-container fluid fill-height pa-0>
    <v-layout align-column-center justify-center column>
      <!-- Product Attributes -->
      <v-card :height="`${this.secondHeight}`" width="100%" color="grey lighten-4" flat>
        <v-container fill-height fluid pa-0>
          <v-layout align-center justify-center column>
            <v-card-text class="text-xs-center mt-5">
              <p class="display-2 mb-3 black--font font-weight-black">{{ $t('productTitle') }}</p>
            </v-card-text>
            <v-card-text style="text-align:justify;">
              <v-container fill-height fluid>
                <v-layout>
                  <v-flex class="text-xs-center pl-5 pr-5"
                    v-for="item in attributes" :key="item.id"
                    xs6 sm6 md3 lg3>
                    <v-card color="transparent" flat transition>
                      <v-layout align-center justify-center>
                        <v-card color="transparent" flat width="30%">
                          <v-img aspect-ratio="1"
                            :src="require('@/assets/icons/'+item.image)"></v-img>
                        </v-card>
                      </v-layout>
                      <v-card-text>
                        {{ item.title }}
                      </v-card-text>
                      <v-card-text class="pt-0">
                        <p>{{ item.content }}</p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-layout>
        </v-container>
      </v-card>

      <!-- Image -->
      <v-card width="100%" color="transparent" flat>
        <v-parallax
          :src="require('@/assets/background/3.jpg')"
          style="padding: 0px">
        </v-parallax>
      </v-card>

      <!-- Product List -->
      <v-card class="mb-3" width="100%" color="grey lighten-4" flat>
        <v-container fluid grid-list-md>
          <v-data-iterator
            :items="products"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            content-tag="v-layout"
            row
            wrap
          >
            <v-flex
              slot="item"
              slot-scope="props"
              xs12
              sm6
              md4
              lg3
            >
              <v-hover>
                <v-card slot-scope="{hover}" class="white--text" color="grey lighten-3" @click="showProduct(props.item)" hover>
                  <v-card-text>
                    <v-img
                      aspect-ratio="1"
                      :src="require('@/assets/background/'+props.item.image)">
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="d-flex transition-fast-in-fast-out white v-card--reveal display-3 black--text"
                          style="height: 20%;">
                          <span class="title"> Quick View </span>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-card-text>
                  <v-card-text>
                    <span class="title black--text font-weight-bold"> {{ props.item.title }} </span>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-data-iterator>
        </v-container>
      </v-card>
      <product-dialog
        :show.sync="showProductDialog"
        :details="productDetails"></product-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import ProductDialog from '../components/dialogs/ProductDialog'

export default {
  components: { ProductDialog },
  data () {
    return {
      windowHeight: 1000,
      secondHeight: 500,
      windowWidth: 500,
      products: [
        { id: 1, title: this.$i18n.t('productTitle1'), description: this.$i18n.t('productDescription1'), image: '1.jpg' },
        { id: 2, title: this.$i18n.t('productTitle2'), description: this.$i18n.t('productDescription2'), image: '4.jpg' },
        { id: 3, title: this.$i18n.t('productTitle3'), description: this.$i18n.t('productDescription3'), image: '8.jpg' },
        { id: 4, title: this.$i18n.t('productTitle4'), description: this.$i18n.t('productDescription4'), image: '7.jpg' },
        { id: 5, title: this.$i18n.t('productTitle5'), description: this.$i18n.t('productDescription5'), image: '6.jpg' },
        { id: 6, title: this.$i18n.t('productTitle6'), description: this.$i18n.t('productDescription6'), image: '5.jpg' }
      ],
      attributes: [
        { id: 1, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle1'), content: this.$i18n.t('productAttributeDescription1') },
        { id: 2, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle2'), content: this.$i18n.t('productAttributeDescription2') },
        { id: 3, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle3'), content: this.$i18n.t('productAttributeDescription3') },
        { id: 4, image: 'service-sample.png', title: this.$i18n.t('productAttributeTitle4'), content: this.$i18n.t('productAttributeDescription4') }
      ],
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      productDetails: {
        id: 1,
        title: this.$i18n.t('productTitle1'),
        description: this.$i18n.t('productDescription1'),
        image: '1.jpg'
      },
      showProductDialog: false
    }
  },

  methods: {
    setSize () {
      this.windowHeight = window.innerHeight
      this.secondHeight = this.windowHeight * 0.75
      this.thirdHeight = this.windowHeight * 0.3
      this.windowWidth = window.innerWidth
    },
    showProduct (item) {
      this.productDetails = item
      this.showProductDialog = true
    }
  },

  mounted () {
    this.setSize()
  }
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Products.vue